import { Autocomplete, TextField, IconButton, Menu, MenuItem } from '@mui/material';
import AddIcon from '@material-ui/icons/Add';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import DatePickerCustom from 'components/DatePickerCustom';
import TextFieldCustom from 'components/TextFieldCustom';
import AutoCompleteDropdown from 'components/autocomplete/AutoCompleteDropdown';
import Crumbs from 'components/crumbs/Crumbs';
import { generateOptionsFromData, sendAPIRequest,displayNotification } from 'helpers';
import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { updateFilter } from 'redux/filtersSlice';

const animal = [{
    label: 'Terrestrial', value: 'terrestrial'
},
{ label: 'Aquatic', value: 'aquatic' },
]
const stage = [

    {id:1,label: "Agreement Phase", value: "agreement_phase" },
    {id:2, label: "Mission", value: "mission" },
    {id:3,label: "Twinning", value: "twinning" },
    { id:4,label: "Workshop", value: "work_shop" }
];
const riskAssessment = [
    { id: 1, name: "From Low to High Risk" },
    { id: 2, name: "consider budget availability" },
    { id: 3, name: "security issues (political situation)" },
    { id: 4, name: "country cooperation" },
    { id: 5, name: "real interest in supporting the activity" },
    { id: 6, name: "Activities with conducted status" }
]
;

const leadStatus = [
    { id: 1, name: "Conducted" },
    { id: 2, name: "In planning" },
    { id: 3, name: "Ongoing" },
    { id: 4, name: "On hold" },
    { id: 5, name: "Uncertain" },
    { id: 6, name: "Cancelled" }
]

const LeadsManagementForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [selectedStage, setSelectedStage] = useState(null);
    const [selectedAnimal, setSelectedAnimal] = useState(null);
    const [regions, setRegions] = useState([]);
    const [countries, setCountries] = useState([]);
    const [selectedMission, setSelectedMission] = useState(null);
    const [activityMission, setActivityMission] = useState(false);
    const [returnParams, setReturnParams] = useState({});
    const filters = useSelector(s => s.filters.report_repository);
    const authData = useSelector(s => s.auth.data);
    const [showTextField, setShowTextField] = useState(false);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedLeadStatus, setSelectedLeadStatus] = useState(null);
    const [selectedRiskAssessment, setSelectedRiskAssessment] = useState(null);
    const [officialRequest, setOfficialRequest] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [sourceLead, setSourceLead] = useState("");
    const [comments, setComments] = useState("");

    // const [anchorEl, setAnchorEl] = useState(null);

    // const handleMenuOpen = (event) => {
    //     setAnchorEl(event.currentTarget);
    // };

    // const handleMenuClose = () => {
    //     setAnchorEl(null);
    // };

    const handleAddOption = () => {
        setShowTextField(!showTextField);
        // setAnchorEl(null); 
    };
    const initialFilters = {

        country_id: [],

        region_id: [],
    };

    useEffect(() => {

        getData();
        loadRegions();
        loadCountries();

    }, []);

    useEffect(() => {
        loadCountries();
    }, [filters.region_id]);

    const handleStageChange = (event, value) => {
        setSelectedStage(value);
        setActivityMission(true);
    }
    let secondAutocompleteOptions = [];
    if (selectedStage && selectedStage.value === 'mission') {
        secondAutocompleteOptions = [
            "Evaluation",
            "Follow Up",
            "Gap Analysis",
            "Laboratories",
            "VLSP",
            "Other",
            "One Health",
            "Workforce"
        ];

    }
    else if (selectedStage && selectedStage.value === 'twinning') {
        secondAutocompleteOptions = [
            'Twinning'
        ];
    }
    else if (selectedStage && selectedStage.value === 'agreement_phase') {
        secondAutocompleteOptions = [
            'VLSP'
        ];
    }
    else if (selectedStage && selectedStage.value === 'work_shop') {
        secondAutocompleteOptions = [
            'Planning',
            'One Health',
            'PPP',
            'Workforce',
            'Orientation',
            'Expert Training',
        ]
    }
    const handleAnimalChange = (event, value) => {
        setSelectedAnimal(value);
    }

    const navigationFunction = (key, value) => {
        let params = { ...filters };
        params[key] = value;
        setFilters({
            ...params,
        });
        params.region_id = params.region_id.join(",");
        params.country_id = params.country_id.join(",");
        params = new URLSearchParams(params).toString();
        let temp = params;
        temp = temp.replaceAll('&', '|');
        setReturnParams(temp);
        // navigate(`/portal/document-management/?${params}`);
    }

    const regionOptions = useMemo(() => {
        return generateOptionsFromData(regions, {
            value: "id",
            label: "region_name",
        });
    }, [regions]);

    const setFilters = (payload) => {
        dispatch(updateFilter({ key: 'report_repository', payload }));
    }
    const getData = async (chk = true) => {
        try {
            setIsLoading(true);
            let params = { ...filters };
            if (chk == false) {
                params = initialFilters;
            }
            params.region_id = params.region_id.join(",");
            params.country_id = params.country_id.join(",");
            params.report_type = params.report_type.join(",");
            params.mission_type = params.mission_type.join(",");
            params.report_year = params.report_year.join(",");
            params.language_id = params.language_id.join(",");
            params.confidentionality_status_id =
                params.confidentionality_status_id.join(",");
            if (authData && authData.id) {
                params.user_id = authData.id;
            }
            params = new URLSearchParams(params).toString();
            const req = await sendAPIRequest(`/api/document-management?${params}`);
            const res = await req.json();
            if (res.success) {
                setData([...res.data]);
            } else {
                setData([]);
                // displayNotification("error", `${t("222", "Error loading data")} [B]`);
            }
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
            console.log(e);
            // displayNotification("error", `${t("222", "Error loading data")} [F]`);
        }
    };

    const loadRegions = async () => {
        try {
            const req = await sendAPIRequest(`/api/regions?fields=id,region_name`);
            const res = await req.json();
            if (res.success) {
                setRegions(res.data);
            }
        } catch (e) {
            console.log(e);
        }
    };
    const countryOptions = useMemo(() => {
        return generateOptionsFromData(countries, {
            value: "id",
            label: "country_complete_name",
        });
    }, [countries]);
    const loadCountries = async (region_id = "") => {
        try {
            let params = {};
            params.region_id = filters.region_id.join(",");
            params = new URLSearchParams(params).toString();
            const req = await sendAPIRequest(`/api/country?${params}`);
            const res = await req.json();
            if (res.success) {
                setCountries(res.data);
            }
        } catch (e) {
            console.log(e);
        }
    };
    const crumbs = [
        {
            path: "/portal/",
            label: t("-1", "Home"),
            active: false,
        },
        {
            path: "/portal/leads-management",
            label: t("-1", "LeadsManagement"),
            active: false,
        },
        {
            path: "/portal/leads-management/create",
            label: t("-1", "Add New Leads"),
            active: true,
        },
    ];

    const handleSave = async () => {
        console.log({
        
        mission_stage:selectedStage?.label,
          official_request:officialRequest,
          mission_status_id:selectedLeadStatus,
      risk_assessment_id:selectedRiskAssessment,
      date:selectedDate,
      source_of_lead: sourceLead,
      comments: comments

        })
        try {
            const data={
                mission_stage_id:selectedStage,
                official_request:officialRequest,
                mission_stage:selectedLeadStatus,
            
                risk_assessment_id:selectedRiskAssessment,
            date:selectedDate,
            source_of_lead: sourceLead,
            comments: comments

            }
           
            // setIsSaving(true);
            const req = await sendAPIRequest(`/api/lead`, 'POST', { ...data });
            const res = await req.json();
            console.log("API Response:", res);
            
            if (res.success) {
                //reloadData();
                displayNotification('success', t("437", "Successfully saved table row data"));
            } else {
                displayNotification('error', `${t("438", "Error saving Table row data")} [B]`);
            }
           // setIsSaving(false);
        } catch (e) {
            console.log(e);
            displayNotification('error', `${t("438", "Error saving Table row data")} [F]`);
            //setIsSaving(false);
        }
    }
    return (
        <>
            <div className='container my-2'>
                <Crumbs crumbs={crumbs} />
                <div className="header card-woah border border-secondary d-flex btn-res1 px-4 py-2 shadow-sm w-100 my-2">
                    <div className="card-title1 lh-1">{t("-1", "Add New Leads")}</div>
                    <div className="header-right-items d-flex align-items-center ms-auto">
                        <div className="ms-auto">
                            <Link to={"/portal/leads-management"} className="ms-1">
                                <button className="btn btn--primary fs-7 lh-1">
                                    {" "}
                                    <i className="fas fa-angle-left text-white" />
                                    {t("32", "Back")}
                                </button>
                            </Link>

                        </div>

                    </div>
                </div>

                <div className="col-12 px-4 mb-3">
                    <div className=" card-title1">{t("-1", "Leads")}</div>
                </div>
                <div className="row px-4 pt-3">
                    <div className="col-md-4 mb-4">
                        <Autocomplete
                            sx={{
                                marginTop: "6px",
                                marginBottom: "6px",
                            }}
                            componentsProps={{
                                paper: {
                                    sx: {
                                        "& .MuiAutocomplete-listbox": {
                                            border: "1px solid black",
                                        },

                                    },
                                },
                                popper: {
                                    modifiers: [
                                        {
                                            name: "offset",
                                            options: {
                                                offset: [0, 10],
                                            },
                                        },
                                    ],
                                },
                            }}
                            options={animal}
                            value={selectedAnimal}
                            // onChange={(event, value) => {

                            //     setSelectedStage(value);
                            // }}
                            onChange={handleAnimalChange}
                            renderOption={(props, option) => (
                                <li
                                    style={{
                                        borderBottom: option !== animal[animal.length - 1] ? "1px solid black" : "none",
                                    }}
                                    {...props}
                                >
                                    {option.label}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextFieldCustom
                                    {...params}
                                    label={"Terrestrial/Aquatic"}
                                    fullWidth
                                    size="small"
                                    required={false}
                                />
                            )}
                            limitTags={2}
                        />
                    </div>
                    <div className="col-md-4 mb-4">
                        <Autocomplete
                            sx={{
                                marginTop: "6px",
                                marginBottom: "6px",
                            }}
                            componentsProps={{
                                paper: {
                                    sx: {
                                        "& .MuiAutocomplete-listbox": {
                                            border: "1px solid black",
                                        },

                                    },
                                },
                                popper: {
                                    modifiers: [
                                        {
                                            name: "offset",
                                            options: {
                                                offset: [0, 10],
                                            },
                                        },
                                    ],
                                },
                            }}
                            options={stage}
                            value={selectedStage}
                            // onChange={(event, value) => {

                            //     setSelectedStage(value);
                            // }}
                            onChange={handleStageChange}
                            renderOption={(props, option) => (
                                <li
                                    style={{
                                        borderBottom: option !== stage[stage.length - 1] ? "1px solid black" : "none",
                                    }}
                                    {...props}
                                >
                                    {option.label}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextFieldCustom
                                    {...params}
                                    label={"Activity Type"}
                                    fullWidth
                                    size="small"
                                    required={false}
                                />
                            )}
                            limitTags={2}
                        />
                    </div>
                    {/* {activityMission (
                        <div className="col-md-4 mb-4">

                            <Autocomplete
                                options={filteredMissions}
                                getOptionLabel={(option) => option.label}
                                value={selectedMission}
                                onChange={(event, value) => setSelectedMission(value)}
                                renderInput={(params) => (
                                    <TextFieldCustom
                                        {...params}
                                        label={t("-1", "Activity/Mission")}
                                        fullWidth
                                        size="small"
                                        required={false}
                                    />
                                )}
                            />

                        </div>)} */}
                    <div className="col-md-4 mb-4">
                        <Autocomplete
                            options={secondAutocompleteOptions}
                            sx={{
                                marginTop: "6px",
                                marginBottom: "6px",
                            }}
                            renderInput={(params) => (
                                <TextFieldCustom
                                    {...params}
                                    label={"Targeted Support Type"}
                                    fullWidth
                                    size="small"
                                    required={false}
                                />
                            )}
                        />
                    </div>
                    {/* <div className="col-md-4 mb-4">
                        <AutoCompleteDropdown
                            error={false}
                            label={t("2880", "Region")}
                            required={false}
                            multiple={true}
                            hasselectall={true}
                            options={regionOptions}

                            onChange={(event, value) => {
                                if (value.some((v) => v.value == "Select all")) {
                                    if (filters.region_id.length == regionOptions.length) {
                                        // Deselect all options
                                        navigationFunction("region_id", []);
                                    } else {
                                        // Select all options
                                        navigationFunction("region_id", regionOptions.map((r) => r.value));
                                    }
                                } else {
                                    navigationFunction("region_id", value.map((r) => r.value));
                                }
                            }
                            }
                            value={filters.region_id}
                        />
                    </div> */}
                    <div className="col-md-4 mb-4">
                        <AutoCompleteDropdown
                            error={false}
                            required={false}
                            label={t("-1", "Country")}
                            multiple={true}
                            hasselectall={true}
                            options={countryOptions}
                            onChange={(event, value) => {
                                if (value.some((v) => v.value == "Select all")) {
                                    if (filters.country_id.length == countryOptions.length) {
                                        // Deselect all options
                                        navigationFunction("country_id", []);
                                    } else {
                                        // Select all options
                                        navigationFunction("country_id", countryOptions.map((r) => r.value));
                                    }
                                } else {
                                    navigationFunction("country_id", value.map((r) => r.value));
                                }
                            }}
                            value={filters.country_id}
                        />
                    </div>
                    <div className="col-md-4 mb-4">
                        <Autocomplete
                            options={["Yes", "No"]}
                            sx={{
                                marginTop: "6px",
                                marginBottom: "6px",
                            }}
                            // open={activityMission} 
                            renderInput={(params) => (
                                <TextFieldCustom
                                    {...params}
                                    label={t("-1", "Official Request")}
                                    fullWidth
                                    size="small"
                                    required={false}
                                />
                            )}
                            onChange={(e,_v)=>{
                                setOfficialRequest(_v.toLowerCase()=='yes'?true:false)
                            }}
                        />
                    </div>
                    <div className="col-md-4 mb-4">
                        <DatePickerCustom
                            label={t("-1", "Add Date")}

                            slotProps={{ textField: { size: "small" } }}
                            sx={{
                                width: "100%", marginTop: "6px",
                                marginBottom: "6px",
                            }}
                            onChange={(e,_v)=>{
                                // setOfficialRequest(_v.toLowerCase()=='yes'?true:false)
                               
                                setSelectedDate(e.toString())
                            }} 
                        />
                    </div>
                    <div className="col-md-4 mb-4">
                        <TextFieldCustom
                            id="outlined-basic"
                            label={t("-1", "Source of Lead")}
                            variant="outlined"
                            // value={form.priority}
                            // onChange={(e) =>
                            //   setForm({ ...form, priority: e.target.value })
                            // }
                            placeholder="How did you hear about it?"
                            fullWidth
                            size="small"
                            value={sourceLead}
                            onChange={(e)=>{
                                setSourceLead(e.target.value)
                            }}
                        />
                        
                    </div>

                    {/* <div className="col-md-4 mb-4">
                        <Autocomplete
                            options={[]}
                            sx={{
                                marginTop: "6px",
                                marginBottom: "6px",
                            }}
                            // open={activityMission} 
                            renderInput={(params) => (
                                <TextFieldCustom
                                    {...params}
                                    label={t("-1", "Funding Source/Project Name")}
                                    fullWidth
                                    size="small"
                                    required={false}
                                />
                            )}
                        />
                    </div> */}
                    <div className="col-md-4 mb-4">
                        <Autocomplete
                            options={[]} // Add your options here
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Funding Source/Project Name"
                                    fullWidth
                                    size="small"
                                    required={false}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {showTextField ? null : (
                                                    <IconButton onClick={handleAddOption}>
                                                        <AddIcon />
                                                    </IconButton>
                                                )}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                        />
                      
                    </div>
                    {showTextField && (
                            <>
                                <div className="col-md-4 mb-4">
                                    <TextFieldCustom
                                        label="New Option"
                                        fullWidth
                                        size="small"
                                        required={false}
                                    />
                                </div>
                            </>
                        )}
                    <div className="col-md-4 mb-4">
                        <Autocomplete
                            options={[]}
                            // open={activityMission} 
                            renderInput={(params) => (
                                <TextFieldCustom
                                    {...params}
                                    label={t("-1", "HQ Contact")}
                                    fullWidth
                                    size="small"
                                    required={false}
                                />
                            )}
                        />
                    </div>
                    <div className="col-md-4 mb-4">
                        <Autocomplete
                            options={[]}
                            // open={activityMission} 
                            renderInput={(params) => (
                                <TextFieldCustom
                                    {...params}
                                    label={t("-1", "Regional Lead")}
                                    fullWidth
                                    size="small"
                                    required={false}
                                />
                            )}
                        />
                    </div>
                    <div className="col-md-4 mb-4">
                        <Autocomplete
                            options={riskAssessment.map(i=>i.name)}
                            renderInput={(params) => (
                                <TextFieldCustom
                                    {...params}
                                    label={t("-1", "Risk Assessment")}
                                    fullWidth
                                    size="small"
                                    required={false}
                                />
                            )}

                            onChange={(e,_v)=>{
                                setSelectedRiskAssessment(riskAssessment.filter((i)=>i.name==_v)[0].id)
                            }}
                        />
                    </div>
                    <div className="col-md-4 mb-4">
                        <Autocomplete
                            options={leadStatus.map((i)=>i.name)}
                            renderInput={(params) => (
                                <TextFieldCustom
                                    {...params}
                                    label={t("-1", "Lead/Mission Status")}
                                    fullWidth
                                    size="small"
                                    required={false}
                                />
                            )}
                            onChange={(e,_v)=>{
                                setSelectedLeadStatus(leadStatus.filter((i)=>i.name==_v)[0].id)
                            }}
                        />
                    </div>
                </div>
                <div className="col-12 mb-3 px-4 mt-2">
                    <div className="card-title1 text-dark">
                        {t("3045", "Comments Timeline")}
                    </div>
                </div>
                <div className="col-12 mb-4 px-4">
                    <TextFieldCustom
                        id="outlined-multiline-flexible"
                        label={t("279", "Comments")}
                        multiline
                        rows={5}
                        //maxRows={5}

                        fullWidth
                        size="small"
                        value={comments}
                        onChange={(e)=>{
                            setComments(e.target.value)
                        }}
                    />
                </div>

                <div className="d-flex mt-3">
                    <button
                        className="btn btn--primary fs-7 lh-1 ms-auto"
                    // disabled={checkRequestSent}
                    onClick={() => handleSave()}
                    >
                        {t("85", "Save")}
                        <i className="fa-sharp fas fa-check text-white ms-2"></i>
                    </button>
                </div>
            </div>

        </>
    )
}

export default LeadsManagementForm
